import { createContext, useCallback, useContext } from 'react'

import { useUser } from './userContext'

import { BuilderTier } from 'types/api.graphql'

type BuilderSubscriptionContextValue = {
  subscription: BuilderTier
  hasSubscription: (subscription: BuilderTier) => boolean
}

const BuilderSubscriptionContext =
  createContext<BuilderSubscriptionContextValue>(null)

export const BuilderSubscriptionProvider = ({ children }) => {
  const { builder } = useUser()

  const hasSubscription = useCallback(
    (subscription: BuilderTier) => {
      const subscriptionTiers = [
        BuilderTier.Free,
        BuilderTier.Lite,
        BuilderTier.Solo,
        BuilderTier.Starter,
        BuilderTier.Standard,
        BuilderTier.Pro,
        BuilderTier.Enterprise,
      ]

      const builderSubscriptionIndex = subscriptionTiers.indexOf(
        builder.subscription
      )

      const subscriptionIndex = subscriptionTiers.indexOf(subscription)

      return builderSubscriptionIndex >= subscriptionIndex
    },
    [builder.subscription]
  )

  return (
    <BuilderSubscriptionContext.Provider
      value={{
        subscription: builder.subscription,
        hasSubscription,
      }}
    >
      {children}
    </BuilderSubscriptionContext.Provider>
  )
}

export const useBuilderSubscription = () =>
  useContext(BuilderSubscriptionContext)
